import React, { useState } from 'react';
import styles from './MessageModal.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const MessageModal = ({ message, onClose, onReply }) => {
  const [reply, setReply] = useState('');

  if (!message) return null;

  const handleReply = () => {
    if (reply.trim()) {
      onReply(message, reply);
      setReply('');
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button onClick={onClose} className={styles.closeButton}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className={styles.header}>
          <h2>{message.subject}</h2>
          <p>De : <strong>{message.expand?.sender?.name || message.sender_email || 'Inconnu'}</strong></p>
          <p>Le : {new Date(message.created).toLocaleString()}</p>
        </div>
        <div className={styles.body}>
          <p>{message.message}</p>
        </div>
        <div className={styles.replySection}>
          <h3>Répondre</h3>
          <textarea 
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            placeholder={`Répondre à ${message.expand?.sender?.name || message.sender_email}`}
            rows="4"
          />
          <button onClick={handleReply} className={styles.replyButton}>
            <FontAwesomeIcon icon={faPaperPlane} /> Envoyer
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageModal;
